import React, { useState } from 'react';
import Mainlayout from '../layout/Mainlayout'
import Gamess from '../data/games.json'
import { useSelector } from 'react-redux'
import Loginreq from '../components/Loginreq';
import Winner from '../components/Winner';
import Correctpeshbini from '../components/Correctpeshbini';
import YourGifts from '../components/YourGifts';




export default function Nmrakan() {



    const xal = []
    const winnersname = []
    const winnersImage = []



    const user = useSelector((state) => state.user)
    const peshbini = JSON.parse(localStorage.getItem('peshbiniakan'));
    

    if (peshbini) {

        peshbini.map((peshbini) => {
            const game = Gamess[peshbini.id - 1]

            const username = [
                `${peshbini.username}`

            ]
            const userImage = [
                `${peshbini.userImage}`

            ]
            if (peshbini.result === game.result) {


                return (


                    winnersname.push(username),
                    winnersImage.push(userImage)
                )


            } else {
                return (

                    null
                )
            }

        })

        peshbini.map((peshbini) => {
            const game = Gamess[peshbini.id - 1]


            if (peshbini.result === game.result && peshbini.username === user.userName) {


                return (

                    xal.push(1)

                )


            } else {
                return (

                    xal.push(0)
                )
            }

        })

        var sum = 0;
        for (let i = 0; i < xal.length; i++) {
            sum += xal[i];
        }
    }





    localStorage.setItem('winnersname', JSON.stringify(winnersname))
    localStorage.setItem('winnersImage', JSON.stringify(winnersImage))



    const navigation = [
        { name: "هەموو پێشبینیەکان", num: 1 },
        { name: "پێشبینیە ڕاستەکان", num: 2 },
        { name: "خەڵاتەکان", num: 3 },

    ]
    const [type, setType] = useState(1)


    const correctpeshbinis = () => {
        return (
            <div className="my-4  md:my-0  w-fit md:w-4/5 overflow-x-auto shadow-md rounded-lg">
                <h1 className='bg-yakam text-center border-b-2 border-chwaram p-1 text-xl text-chwaram'>{user.userName}</h1>
                <table className=" text-center w-full relative text-xs md:text-lg text-black bg-slate-100 ">
                    <thead className="md:text-lg text-chwaram uppercase bg-yakam ">
                        <tr>

                            <th scope="col" className=" md:p-5 p-2">
                                خاڵ
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                ئەنجام
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                پێشبی
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                جۆری یاری
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                یاری
                            </th>


                        </tr>
                    </thead>
                    <tbody className='bg-dwam'>

                        {peshbini.map((peshbini) => {


                            const game = Gamess[peshbini.id - 1]

                            if (peshbini.username === user.userName && peshbini.result === game.result) {
                                return (
                                    <>
                                        {

                                            peshbini.result === game.result ? (

                                                <tr className="bg-dwam divide-y-2 divide-yakam text-shasham border-black">
                                                    <th scope="row" className="text-center text-md uppercase md:p-1  p-2 font-medium  whitespace-nowrap">
                                                        {game.gametype === 'کۆمەڵەکان' ?
                                                            (
                                                                1
                                                            ) :
                                                            (
                                                                1
                                                            )
                                                        }
                                                    </th>
                                                    <td className=" md:p-5 p-2">
                                                        {game.result}
                                                    </td>
                                                    <td className=" md:p-5 p-2">
                                                        {peshbini.result}
                                                    </td>
                                                    <td className=" md:p-5 p-2">
                                                        {peshbini.gametype}
                                                    </td>
                                                    <th className=" md:p-5 p-2">
                                                        {peshbini.team1} - {peshbini.team2}
                                                    </th>
                                                </tr>

                                            )
                                                : (

                                                    <tr className="bg-dwam divide-y-2 divide-yakam text-shasham border-black">
                                                        <th scope="row" className="text-center text-md uppercase md:p-1  p-2 font-medium  whitespace-nowrap">
                                                            {game.gametype === 'کۆمەڵەکان' ?
                                                                (
                                                                    0
                                                                )
                                                                :
                                                                (
                                                                    0
                                                                )
                                                            }
                                                        </th>
                                                        <td className=" md:p-5 p-2">
                                                            {game.result}
                                                        </td>
                                                        <td className=" md:p-5 p-2">
                                                            {peshbini.result}
                                                        </td>
                                                        <td className=" md:p-5 p-2">
                                                            {peshbini.gametype}
                                                        </td>
                                                        <th className=" md:p-5 p-2">
                                                            {peshbini.team1} - {peshbini.team2}
                                                        </th>
                                                    </tr>

                                                )
                                        }
                                    </>
                                )

                            }
                            else {
                                return (
                                    null
                                )
                            }

                        })
                        }





                    </tbody>
                </table>
            </div>
        )
    }
    const allpeshbinis = () => {
        return (
            <div className="my-4  md:my-0  w-fit md:w-4/5 overflow-x-auto shadow-md rounded-lg">
                <h1 className='bg-yakam text-center border-b-2 border-chwaram p-1 text-xl text-chwaram'>{user.userName}</h1>
                <table className=" text-center w-full relative text-xs md:text-lg text-black bg-slate-100 ">
                    <thead className="md:text-lg text-chwaram uppercase bg-yakam ">
                        <tr>

                            <th scope="col" className=" md:p-5 p-2">
                                خاڵ
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                ئەنجام
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                پێشبی
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                جۆری یاری
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                یاری
                            </th>


                        </tr>
                    </thead>
                    <tbody>

                        {peshbini ?
                            (

                                peshbini.map((peshbini) => {


                                    const game = Gamess[peshbini.id - 1]

                                    if (peshbini.username === user.userName) {
                                        return (
                                            <>
                                                {

                                                    peshbini.result === game.result ? (

                                                        <tr className="bg-dwam divide-y-2 divide-yakam text-shasham border-black">
                                                            <th scope="row" className="text-center text-md uppercase md:p-1  p-2 font-medium  whitespace-nowrap">
                                                                {game.gametype === 'کۆمەڵەکان' ?
                                                                    (
                                                                        1
                                                                    ) :
                                                                    (
                                                                        1
                                                                    )
                                                                }
                                                            </th>
                                                            <td className=" md:p-5 p-2">
                                                                {game.result}
                                                            </td>
                                                            <td className=" md:p-5 p-2">
                                                                {peshbini.result}
                                                            </td>
                                                            <td className=" md:p-5 p-2">
                                                                {peshbini.gametype}
                                                            </td>
                                                            <th className=" md:p-5 p-2">
                                                                {peshbini.team1} - {peshbini.team2}
                                                            </th>
                                                        </tr>

                                                    )
                                                        : (

                                                            <tr className="bg-dwam divide-y-2 divide-yakam text-shasham border-black">
                                                                <th scope="row" className="text-center text-md uppercase md:p-1  p-2 font-medium  whitespace-nowrap">
                                                                    {game.gametype === 'کۆمەڵەکان' ?
                                                                        (
                                                                            0
                                                                        )
                                                                        :
                                                                        (
                                                                            0
                                                                        )
                                                                    }
                                                                </th>
                                                                <td className=" md:p-5 p-2">
                                                                    {game.result}
                                                                </td>
                                                                <td className=" md:p-5 p-2">
                                                                    {peshbini.result}
                                                                </td>
                                                                <td className=" md:p-5 p-2">
                                                                    {peshbini.gametype}
                                                                </td>
                                                                <th className=" md:p-5 p-2">
                                                                    {peshbini.team1} - {peshbini.team2}
                                                                </th>
                                                            </tr>

                                                        )
                                                }
                                            </>
                                        )

                                    }
                                    else {
                                        return (
                                            null
                                        )
                                    }

                                })
                            )
                            :
                            (
                                null
                            )
                        }





                    </tbody>
                </table>
            </div>
        )
    }
    const yourGifts = () => {
        return (
            <YourGifts />
        )
    }






    return (
        <>

            {
                user.isAuthed ?
                    (
                        <Mainlayout>

                            <div className=' bg-dwam min-h-screen'>
                                <div className=' container mx-auto'>



                                    {winnersname ? (
                                        <>
                                            <Correctpeshbini />
                                            <Winner />

                                        </>
                                    ) :
                                        (

                                            null
                                        )
                                    }

                                    <div className=' bg-yakam w-full '>

                                        <div className='flex flex-row' >
                                            {navigation.reverse().map((nav) => {
                                                return (
                                                    <>
                                                        <div onClick={() => { setType(nav.num) }} className='w-1/3 p-3 h-full text-xs md:text-xl cursor-pointer item-center text-center hover:bg-seyam hover:text-yakam text-chwaram'><p className=''>{nav.name}</p></div>
                                                    </>
                                                )
                                            })}
                                        </div>

                                    </div>


                                    <div className='bg-dwam w-full p-3 md:p-8 flex flex-col  md:flex-row-reverse md:items-start items-center md:justify-between' >


                                        {type === 1 ?
                                            (
                                                allpeshbinis()
                                            )
                                            :
                                            type === 2 ?
                                                (
                                                    correctpeshbinis()
                                                )
                                                :
                                                type === 3 ?
                                                    (
                                                        yourGifts()
                                                    )
                                                    :
                                                    (
                                                        null
                                                    )
                                        }
                                        <div>

                                            <div class="overflow-x-auto relative shadow-md w-full rounded-lg">
                                                <table class="w-full text-sm text-left text-chwaram ">
                                                    <thead class="text-xs md:text-lg text-chwaram uppercase bg-yakam ">
                                                        <tr>
                                                            <th scope="col" class="py-3 px-6">
                                                                کۆی گشتی خاڵەکانت
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row" class="py-4 px-6 md:text-lg text-center font-medium text-shasham whitespace-nowrap ">
                                                                {sum}
                                                            </th>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                    </div>


                                </div>
                            </div>
                        </Mainlayout>
                    )
                    :
                    (
                        <Loginreq />
                    )
            }
        </>


    )
}